define('ads/ad',['lib', 'underscore'], function(lib, _) {
	'use strict';

	var takeoverImageSizes = [
		[3, 3],
		[1920, 1080]
	];

	function Ad(ad) {
		this.ad = ad;
		this.$container = $('#' + this.ad.targetId);

		if (this.isEmpty()) {
			this.collapse();
			return null;
		}

		lib.raf(_.bind(function() {
			this.$container.addClass('ad-loaded').show();

			this.setInitialSkyscraperRight();
			this.setWallpaper();
			this.setHorseshoe();
			this.setVideo();
		}, this));
	}

	_.extend(Ad.prototype, {
		isEmpty: function() {
			return this.ad.empty;
		},
		collapse: function() {
			if (!this.$container || this.$container.length <= 0) {
				return;
			}

			lib.raf(_.bind(function() {
				this.$container.hide();
			}, this));
		},
		isInitialSkyscraperRight: function() {
			return this.ad.targetId === 'ad-skyscraperright_1';
		},
		setInitialSkyscraperRight: function() {
			if (!this.isInitialSkyscraperRight()) return;

			// Hack to adjust wallpaper scroll height based on fullscreen ad's height
			var fullscreenAd = document.getElementById('ad-fullscreen');
			if (fullscreenAd) {
				var $sibling = $(fullscreenAd.previousElementSibling);
				var height = $sibling.offset().top + $sibling.height() + 18;

				var wpContainer = document.getElementById('wallpaper-background-container');
				wpContainer.style.height = 'calc(' + height + 'px - 100vh)';
			}
		},
		isWallpaper: function() {
			return this.ad.targetId === 'ad-wallpaper';
		},
		setWallpaper: function() {
			if (!this.isWallpaper()) return;

			lib.$html().addClass('wallpaper-bg');
		},
		isHorseshoe: function() {
			return this.ad.targetId === 'ad-skyscraperleft_1';
		},
		setHorseshoe: function() {
			if (!this.isHorseshoe()) return;

			lib.$html().addClass('has-horseshoe');
		},
		isVideo: function() {
			return this.ad.adResponse && this.ad.adResponse.ads[0].ad_type === 'video';
		},
		setVideo: function() {
			if (!this.isVideo()) return;

			$('#' + this.ad.targetId).css({
				'height': this.ad.adResponse.ads[0].player_height
			});
		},
	});

	return Ad;
});

